const forFlow = (apiObject) => {
  const { htmlBody, htmlUrl, body } = apiObject;
  return {
    ...apiObject,
    htmlBody: htmlBody ?? `<p></p>`,
    body: body ?? ``,
    htmlUrl: htmlUrl,
  };
};

const filterActionHttpRequest = (obj, filter) =>
  Object.entries(obj).reduce(
    (acc, [key, val]) =>
      filter.includes(key) && val === null ? acc : { ...acc, [key]: val },
    {}
  );

const forApi = (step) => {
  const {
    actionHttpRequest: {
      dataPayload: _dataPayloadEdit,
      urlParts: _urlPartsEdit,
      ...orgActionHttpRequest
    } = {},
    details: {
      dataPayload: _dataPayloadCreate,
      urlParts: _urlPartsCreate,
      ...orgDetails
    } = {},
  } = step;

  const actionHttpRequest = {
    ...filterActionHttpRequest(orgActionHttpRequest, ['htmlBody', 'htmlUrl']), // [todo] remove once we handle these
    ...orgDetails,
  };

  const details = {
    ...actionHttpRequest,
  };

  return { actionHttpRequest: actionHttpRequest || {}, details: details || {} };
};

export const httpRequestDTO = {
  forApi,
  forFlow,
};
